import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Alfred from './AlfredComponents/Alfred';
import Summary from './SummaryComponents/Summary';
// import axios from 'axios';
import Chart from './ChartComponents/Chart';
import ReportPage from './ReportComponents/Report';
import DownloadArea from './DownloadComponents/DownloadArea';
import Notifications from './NotificationComponents/Notifications';
// import TopInfo from './commonComponents/TopInfo';
import Topfilters from './commonComponents/Topfilters';
import DashBoardHome from './HomeComponents/DashboardMonitoring';
import AlfredComponent from './commonComponents/AlfredComponent';
import CallAPI from '../../adminpanel/components/commonComponents/AxiosHelper';
import DashBoardSideBar from '../../adminpanel/components/AdminSideBar';
import { getData, getToolsData, get_property_metric_breakup, getQuestion, setQuestion, set_initial_values_url, setInsightFunction, set_disp_objects, setDrillHandle, setSummary, setAuthData, removeFilter, handle_compare, handle_quadrant, handle_transpose_table, setData, setTableActions, saveFilterToggleHandle, handle_restricted_Filter, setKpiColumnConfig, setChartQuestion, setGlobalFilters } from '../actions/index';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';
import FilterComponent from './commonComponents/FilterComponent';
import OldFilterComponent from './commonComponents/FilterComponent.2020-08-31'
import SidebarInsight from './commonComponents/SidebarInsight';
import PinboardcreateCombination from './PinboardComponents/Pinboard';
import PinboardList from './PinboardComponents/PinboardList';
import NoDataFound from './commonComponents/NoDataFound'
import DescriptionComponent from './commonComponents/DescriptionComponent'
import SettingsComponent from './SettingComponents/setting';
import AllDashboards from './DashboardComponents/AllDashboards';
import APIRequest from './Admin-version2/APIRequest';
// import ErrorBoundary from './commonComponents/ErrorBoundary'    // Not in use for now. Handling through NoDataFound class
import './dashboardParent.css'
import { getParameters } from '../../adminpanel/components/commonComponents/Helper';
import LoadingComponent from './commonComponents/LoadingComponent';

var AlfredSearchBodyMargin = {}, counter = 1;
class DashBoardParent extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            open: false,
            property: props.property,
            breakup: props.breakup,
            include: props.include,
            exclude: props.exclude,
            alfred_question: '',
            endDate: props.endDate,
            startDate: props.startDate,
            chartCat: props.chartCat,
            chartType: "",
            loading:false,
            period: props.period,
            renderDataStatus: props.renderDataStatus,
            pageError: false,
            isReloading: false,
        }
        this.menu_array = {
            "search": { "name": "search", "label": 'Search', "link": "/alfred", "icon": "search", "showMenu": false },
            "summary": { "name": "summary", "label": 'Summary', "link": "/summary", "icon": "monitor", "showMenu": false },
            "chart": { "name": "chart", "label": 'Charts', "link": "/chart", "icon": "bar-chart", "showMenu": false },
            "report": { "name": "report", "label": 'Reports', "link": "/report", "icon": "server", "showMenu": false },
            "dataset": { "name": "dataset", "label": 'Datasets', "link": "/start", "icon": "database", "showMenu": false }
        };
        if (!localStorage.Dataset && props.authData) {
            let tempJson = { siteId: props.authData.siteId };
            localStorage.setItem("Dataset", JSON.stringify(tempJson));
        }
        // if(!props.selectedMetric){//
        //     this.props.setQuestion({ alfred_question: "" });
        //     this.props.set_initial_values_url({ "property": props.property, "breakup": props.breakup, "metric": props.selectedMetric, "startDate": props.startDate, "endDate": props.endDate })
        // }
        this.drillHandle = this.drillHandle.bind(this);
        // this.checkSession = this.checkSession.bind(this);
        this.filterHandleChange = this.filterHandleChange.bind(this);
        this.changeDataSet = this.changeDataSet.bind(this);
        this.handleLoadingStatus = this.handleLoadingStatus.bind(this)
        this.checkForQueryInURL = this.checkForQueryInURL.bind(this)
    }

    checkForQueryInURL = () => {
        const { pathname } = this.props.location

        // Check if the word 'query' exists in the URL parameters
        if (pathname.includes('/query')) {
            // Show the loader if 'query' is present
            this.setState({ isReloading: true });
        } else {
            // Hide the loader if 'query' is not present
            this.setState({ isReloading: false });
        }
    };

    componentDidMount() {
        this.checkForQueryInURL();
    }


    componentWillMount() {

        metricGlobal = this.props.metricGlobal;
        // if (this.props.authData && (this.props.allDashboards === undefined || Object.keys(this.props.allDashboards).length === 0)) {
        if (this.props.authData && (this.props.dataResult === undefined || this.props.dataResult.length === 0 || (this.props.dashbordGroups && this.props.dashbordGroups.length == 0 ||(this.props?.dataResult[0] && this.props?.dataResult[0]?.siteId != this.props?.authData?.siteId)))) {
            // this.props.getData(this.props.dataResult, this.props.authData);
            let postData = {
                userId: this.props.authData ? this.props.authData.userId : null
            };
            let params = { type: 'dashboard', siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null }
            let that = this;
            
            CallAPI('POST', '/app/tools', postData, params, 0, function (response) {
                that.props.getToolsData(response)
            }, that.props.authData)
        }
        if (metricGlobal && metricFunction && metricGlobal.length > 0 && metricFunction.length > 0) {
            metricPossibleCombinations = createCombination(metricGlobal, metricFunction);
            if (this.state.property !== this.props.property || this.state.breakup !== this.props.breakup || this.state.alfred_question !== this.props.alfred_question || this.state.period !== this.props.period || this.state.startDate !== this.props.startDate || this.state.endDate !== this.props.endDate || this.state.include !== this.props.include || this.state.exclude !== this.props.exclude || this.props.renderDataStatus || metricGlobal.length == 0) {
                let callHandle = false;
                if (this.state.currentPageName == 'insight') {
                    if (this.state.insightPoint || this.state.insightDate) callHandle = true
                } else { callHandle = true }
                if (callHandle) {
                    if (this.state && typeof this.state.SelectedBreakUp === "function") { }
                    else this.handleChange({ ...this.state, renderDataStatus: true });
                }
            }
        }
        this.setState({ loadStatus: true });
    }
    componentWillReceiveProps(nextProps) {
        feather.replace()
        if (getParameters('nav') == 'new') {
            this.componentDidUpdate({ ...nextProps, 'callNav': true })
        } else {
            if (this.props.chartCat !== nextProps.chartCat || this.props.insightDate !== nextProps.insightDate || this.state.property !== nextProps.property || (this.state.breakup !== nextProps.breakup) || this.state.alfred_question !== nextProps.alfred_question || this.state.period !== nextProps.period || this.state.startDate !== nextProps.startDate || this.state.endDate !== nextProps.endDate || this.state.include !== nextProps.include || this.state.exclude !== nextProps.exclude || this.state.insightPoint != nextProps.insightPoint || nextProps.renderDataStatus || metricGlobal.length == 0) {
                this.setState({ ...nextProps, loadStatus: true, pageError: false });
                if (this.state.property != nextProps.property || this.state.breakup != nextProps.breakup || this.state.include != nextProps.include || this.state.exclude != nextProps.exclude || metricGlobal.length == 0) {
                    let callHandle = false;
                    if (this.state.currentPageName == 'insight') {
                        if (this.state.insightPoint || this.state.insightDate) callHandle = true
                    } else { callHandle = true; }
                    if (callHandle) {
                        if (nextProps && typeof nextProps.SelectedBreakUp === "function") { }
                        else this.handleChange({ ...nextProps, renderDataStatus: true });
                    }
                }
            }
           
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps?.location?.pathname) {
            this.checkForQueryInURL();
          }
        feather.replace()
        if (prevProps.callNav == true || this.props?.location?.pathname !== prevProps?.location?.pathname || this.props.location.search!==prevProps.location.search) {
            // this.checkSession();
            if (prevProps.callNav == true ) {
                let transpose = getParameters('transpose')
                let kpiMonitoring = getParameters('kpiMonitoring')
                let booleanKPIMVal = kpiMonitoring ? JSON.parse(kpiMonitoring) : kpiMonitoring
                let currentUrl = window.location.search + `&compare=&analysis=&clusterCount=&transpose=${transpose}&kpiMonitoring=${booleanKPIMVal}`
                let urlObj =Object.fromEntries(new URLSearchParams(currentUrl));

                // get first pinbaord id when the group change
                let pathNameSplit = window.location.pathname.split('/')
                if (pathNameSplit[1] && pathNameSplit[1] == 'pinboard' && prevProps.dashbordGroups) {
                    let group = getParameters('group')
                    let dashbordGroups = prevProps.dashbordGroups
                    let dashbordGroupsLength = dashbordGroups.length
                    for (let i = 0; i < dashbordGroupsLength; i++) {
                        if (group == dashbordGroups[i]['dashboard_group']) {
                            id_dashboard = dashbordGroups[i]['idDashboard'];
                            break;
                        }
                    }
                }

                urlObj['currentPageName'] = prevProps.currentPageName
                updateURL(urlObj, 'new', false)
                this.props.handle_transpose_table({ transpose: transpose, kpiMonitoring: booleanKPIMVal })
                this.props.handle_compare({ compare: null });
                this.props.handle_quadrant({ analysis: false });
            }
            if (alfredConfig == 'yes') {
                if (this.props?.location?.pathname !== prevProps?.location?.pathname  && getParameters('question') == undefined || prevProps.callNav == true) {
                    this.props.setQuestion({ alfred_question: "" });
                }
            } else {
                this.props.setQuestion({ alfred_question: "" });
            }
            // this.props.setQuestion({ alfred_question: "" });
            this.props.setInsightFunction({ insight: false, deepInsight: false, enableDescription: false, insightDate: null, point: null, insightSortOrder: null });
        }
    }
    drillHandle = (demoVar, type, event, selectedMetric = null, dateSelected = null, clickedDimension = null, allCurrentValues = null, componentData = null, insightSortOrder = null) => {
        // history.pushState({}, null, window.location.href.replace("?nav=new",""));
        // history.pushState({}, null, window.location.href.replace("&nav=new",""));
        if (alfredConfig == 'no' && this.state.alfred_question != '') {
            const url = new URL(window.location);
            const params = new URLSearchParams(url.search);
            params.delete('question');
            url.search = params.toString();
            history.replaceState(null, '', url);
            this.props.setQuestion({ alfred_question: "" })
        }
        let startDate = allCurrentValues ? allCurrentValues?.startDate: this.state.startDate && this.state.startDate
        let endDate = allCurrentValues ? allCurrentValues?.endDate : this.state.endDate && this.state.endDate
        let period = this.state.period!=undefined && this.state.period!=null ? this.state.period:allCurrentValues && allCurrentValues?.period
        if (componentData) {
            componentData.startDate ? startDate = componentData.startDate : null
            componentData.endDate ? endDate = componentData.endDate : null
            componentData.period ? period = componentData.period : null
        }
        
        if (event != 'back' && event != 'insight' && event != 'deepInsight') {
        }
        if (event == 'back') {
            const history = window.location;
            console.log(window.history.back())
            // history.goBack();
            var urlObj;
            setTimeout(() => {
                urlObj = Object.fromEntries(new URLSearchParams(window.location.search))
                this.componentDidUpdate({ ...urlObj, 'callNav': true })
            }, 10)
        } else if (event == 'insight') {
            this.props.setInsightFunction({ "point": demoVar, pointMetric: selectedMetric, insightDate: encodeURIComponent(dateSelected), insight: true, deepInsight: false, enableDescription: true, clickedDimension: clickedDimension, componentData: componentData, insightSortOrder: insightSortOrder,breakup: componentData?.breakUp,include : componentData?.include, exclude : componentData?.exclude });
            defaultFilterFlag = '0'
            this.props.removeFilter()
            // this.setState({
            //     point: demoVar,
            //     insightMetric: selectedMetric,
            //     insightDate: dateSelected
            // });
            // this.refs.sidebarInsightRef.handleInsightEnable(true);
            // closeSidebar('FilterDiv');
            // if (jQuery(window).width() >= mobile_width){
            //     openSidebar('SidebarInsightDiv', filter_desktop_width);
            //     jQuery("#main-content").css("marginRight", main_content_div_filter);
            // }else openSidebar('SidebarInsightDiv', filter_mobile_width);
        } else if (event == 'deepInsight') {
            this.props.setInsightFunction({ "point": demoVar, pointMetric: selectedMetric, insightMetric: BaseInsightMetric, insightDate: dateSelected, insight: false, deepInsight: true, enableDescription: false, clickedDimension: clickedDimension, insightSortOrder: null });
            defaultFilterFlag = '0'
            this.props.removeFilter()
        } else if (event == "chart") {
            var trendURL = null;
            // var trendProperty = getUpdatedPropertyForViewTrend(clickedDimension ? clickedDimension : this.state.property, demoVar, this.state);
            // Multiple properly values then select clickedDimension
            let trendPropertyToUse = this.props.pageName == 'pinboard' && allCurrentValues ? allCurrentValues?.property :this.props.pageName == 'pinboard' && allCurrentValues?.propertyDisp?.length > 0 ? allCurrentValues?.propertyDisp?.[0].value : this.state.property && this.state.property.split(',').length > 1 && this.state.property.split(',')?.[0].split(';')[1] ? clickedDimension : this.state.property;
            trendPropertyToUse = this.props.pageName == 'pinboard' && allCurrentValues && allCurrentValues?.property ? allCurrentValues?.property : allCurrentValues && allCurrentValues?.propertyDisp?.[0]?.value ? allCurrentValues?.propertyDisp?.[0]?.value : allCurrentValues?.selectedProperty ? allCurrentValues?.selectedProperty : trendPropertyToUse;
            var trendProperty = getUpdatedPropertyForViewTrend(trendPropertyToUse, demoVar, this.state);
            var trendInclude =this.props.pageName == 'pinboard' && allCurrentValues ?allCurrentValues?.include : this.state.include 
            var trendExclude = this.props.pageName == 'pinboard' && allCurrentValues ?allCurrentValues?.exclude : this.state.exclude 
            var trendMetric = refineURLData(selectedMetric) ? selectedMetric : refineURLData(getParameters('metric'))
            trendMetric = trendMetric ? trendMetric : refineURLData(getParameters('selectedMetric'))
            trendMetric = trendProperty && trendProperty.split(',')[1] ? trendMetric.split(',')[0] : trendMetric
            trendMetric = trendMetric ? trendMetric: allCurrentValues && allCurrentValues?.selectedMetric;
            let selectedBreakup = typeof this.state.SelectedBreakUp === 'function' ? '' : this.state.SelectedBreakUp; 
            selectedBreakup = selectedBreakup ? selectedBreakup : this.state.breakup!="null"? this.state.breakup :null;
            selectedBreakup = this.props.pageName == 'pinboard' && allCurrentValues ? allCurrentValues?.breakUp : selectedBreakup != "null" ? selectedBreakup:null;
            if (refineURLData(trendProperty)) {
                selectedBreakup = selectedBreakup ? (trendProperty + ',' + selectedBreakup).replace(/,+$/,'') : trendProperty;
                trendProperty = null;
            } 
            var dateAndGranManipulation = handleDrillAcrossDate(this.props.pageName == "pinboard" && allCurrentValues && allCurrentValues.period ? allCurrentValues.period : this.state.period != null && this.state.period != undefined ? this.state.period : null, dateSelected, startDate, endDate);            
            startDate = dateAndGranManipulation['startDate'];
            endDate = dateAndGranManipulation['endDate'];
            // selectedBreakup = refineURLData(trendProperty) ? (trendProperty + ',' + selectedBreakup).replace(/,+$/,'') : selectedBreakup;
            // let period = getPeriodBasedOnDates(startDate, endDate, period, 'Line')
            let periodNew = getPeriodBasedOnDates(startDate, endDate, null, 'Line')
            trendURL = window.location.origin + '/chart/chartData?property=' + encodeURIComponent(trendProperty) + `&propertyValues=null&metric=${trendMetric}&breakup=${selectedBreakup}&include=${trendInclude}&exclude=${trendExclude}&startDate=${startDate}&endDate=${endDate}`;
            trendURL += `&chartType=&chartStyle=Line&getAnomlyDetection=false&chartCat=Line&period=${periodNew}`;

            var win = window.open(trendURL, '_blank');
            win.focus();
            // 
            // var url = `${window.location.origin}/chart/chartData${window.location.search}`;

            // var tempBreakUp = this.state.SelectedBreakUp;

            // if (demoVar != 'Total' && demoVar) {
            //     var objBreak = breakUpget(this.state, demoVar);
            // }else {
            //     var objBreak = {
            //         SelectedBreakUp: this.state.SelectedBreakUp,
            //         SelectedBreakUpDisp: this.state.SelectedBreakUp
            //     };
            // }

            // url = url.replace('property=' + encodeURIComponent(this.state.property), 'property=null');
            // url = url.replace('selectedMetric=', 'metric=');
            // url = url.replace('breakup=' + encodeURIComponent(tempBreakUp), 'breakup=' + encodeURIComponent(objBreak.SelectedBreakUp));
            // url += '&chartCat=Line';

            // url = url.replace('chartType=' + encodeURIComponent(this.state.chartType), 'chartType=Month');

            // var win = window.open(url, '_blank');
            // win.focus();
        } else {
            var thisState = this.state;
            thisState.property = this.props.pageName == 'pinboard' && allCurrentValues ? allCurrentValues.selectedProperty : this.state.property;
            if (type != null) {
                // if (!this.state.property || this.state.property == "null") {
                if (!refineURLData(clickedDimension) && !refineURLData(thisState.property)) {
                    demoVar = null;
                }
                // var startDate = this.state.startDate;
                // var endDate = this.state.endDate;
                // var period = this.state.period;
                var startDateDisp = null
                var endDateDisp = null;
                let chartCat =  this.state.chartCat
                if (dateSelected) {
                    // Updated by Anurag. Date: 13 Feb 2019. Purpose: To consider the date clicked in table trend
                    var dateAndGranManipulation = handleDrillAcrossDate(this.props.pageName == "pinboard" && allCurrentValues && allCurrentValues.period ? allCurrentValues.period : this.state.period != null && this.state.period != undefined ? this.state.period : null, dateSelected, startDate, endDate, this.state.chartCat);
                    // period = dateAndGranManipulation['chartType'];
                    period = 'Aggregate';   // This is to show Aggregated data on breakdown
                    chartCat = 'Column'
                    startDate = dateAndGranManipulation['startDate'];
                    endDate = dateAndGranManipulation['endDate'];
                    startDateDisp = dateAndGranManipulation['startDateDisp'];
                    endDateDisp = dateAndGranManipulation['endDateDisp'];
                }
                if (!nonTimeseriesChartCat?.includes(this?.state?.chartCat) && !nonTimeseriesChartCat?.includes(allCurrentValues?.chartCat)) {
                    chartCat = 'Column'
                } else {
                    chartCat = this.state.chartCat
                }

                if ((demoVar != null && demoVar != "Total") || ((demoVar == 'Total' || demoVar == null) && this.props.pageName === 'pinboard')) {
                    demoVar = demoVar == selectedMetric ? '' : demoVar; // To handle the case in transpose table when user tries to drill down and across by clicking on metric. In that case demoVar is same as selectedMetric.                    
                    var objBreak = demoVar ? breakUpget(this.state, demoVar, '', clickedDimension) : '';
                    var newPropertyLabel = type.value;
                    var newPropertyDisp = type.obj; // To handle cross tab and transport table
                    if ((event == 'drillAcross' || event == 'drillDown') && thisState.property) {
                        var temp = thisState.property && thisState.property.split(',');
                        // Remove second dimension from multi dimension if both the break ups are considered
                        if (!clickedDimension && objBreak['length'] > 1) {
                            while (temp.length > 1) {
                                temp.pop();
                                this.state.propertyDisp.pop();
                            }
                        }
                        let dimensionIndex = 0;
                        if (clickedDimension) {
                            let dimensionSplit = thisState.property.split(',').map(item => item.trim().toLowerCase());
                            dimensionIndex = dimensionSplit.indexOf(clickedDimension.toLowerCase());
                        }
                        temp[dimensionIndex] = newPropertyLabel;
                        newPropertyLabel = temp.join();
                        // temp = this.state.propertyDisp;
                        // temp[dimensionIndex] = newPropertyDisp;
                        // newPropertyDisp = temp;
                    }

                    if (this.props.pageName === 'pinboard') {
                        let url = null
                        if(allCurrentValues) {
                            let breakup = allCurrentValues?.breakUp && allCurrentValues?.breakUp != undefined && allCurrentValues?.breakUp != null ? allCurrentValues?.breakUp : objBreak.SelectedBreakUp;
                            if (breakup && objBreak?.SelectedBreakUp) {
                                if (breakup !== objBreak?.SelectedBreakUp) {
                                    breakup = objBreak?.SelectedBreakUp != null && objBreak?.SelectedBreakUp != undefined ? `${breakup},${objBreak.SelectedBreakUp}` : breakup;
                                }
                            }
                            let include = allCurrentValues?.include && allCurrentValues?.include != undefined && allCurrentValues?.include != null ? allCurrentValues?.include : '';
                            let exclude = allCurrentValues?.exclude && allCurrentValues?.exclude != undefined && allCurrentValues?.exclude != null ? allCurrentValues?.exclude : '';
                            // breakup = componentData.breakUp;
                            // include = componentData.include;
                            // exclude = componentData.exclude;

                            if (componentData ) {
                                if (breakup ) {
                                    if (breakup !== componentData.breakUp) {
                                        breakup = componentData.breakUp != null && componentData.breakUp != undefined ? `${breakup},${componentData.breakUp}` : breakup;
                                    }
                                } else {
                                    breakup = componentData.breakUp;
                                }
                    
                                if (include ) {
                                    if (include !== componentData.include) {
                                        include = componentData.include != null && componentData.include != undefined ? `${include},${componentData.include}` : include;
                                    }
                                } else {
                                    include = componentData.include;
                                }
                    
                                if (exclude) {
                                    if (exclude !== componentData.exclude) {
                                        exclude = componentData.exclude != null && componentData.exclude != undefined ? `${exclude},${componentData.exclude}` : exclude;
                                    }
                                } else {
                                    exclude = componentData.exclude;
                                }
                            
                            }
                            if (allCurrentValues.report) {
                                url = window.location.origin + `/report?property=${encodeURIComponent(newPropertyLabel)}&metric=${encodeURIComponent(allCurrentValues.selectedMetric ? allCurrentValues.selectedMetric : selectedMetric)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&chartCat=report&period=${encodeURIComponent(allCurrentValues.period)}&breakup=${encodeURIComponent(breakup)}&include=${encodeURIComponent(include)}&exclude=${encodeURIComponent(exclude)}&multiDim=${encodeURIComponent(allCurrentValues.multiDim)}&transpose=${encodeURIComponent(allCurrentValues.transpose)}`
                            } else if (allCurrentValues.chart) {
                                url = window.location.origin + `/chart/chartData?property=${encodeURIComponent(newPropertyLabel)}&metric=${encodeURIComponent(selectedMetric)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&chartCat=${chartCat!=''?chartCat:allCurrentValues.chartDisp}&breakup=${encodeURIComponent(breakup)}&include=${encodeURIComponent(include)}&exclude=${encodeURIComponent(exclude)}&multiDim=true}`
                            }
                            let win = window.open(url, '_blank');
                            win.focus();
                        }                        
                    } else {
                        var objData = { property: newPropertyLabel, breakup: null, include: objBreak.SelectedBreakUp, point: null, insightPoint: null, insight: null, deepInsight: null, period: period, startDate: startDate, endDate: endDate, includeDisp: objBreak.SelectedBreakUpDisp, chartCat: chartCat }
                        let finalObj = handleParamsToSet({ include: null, exclude: null, filter: null, property: null }, objData, this)
                        this.props.set_disp_objects({ ...finalObj });
                    }
                    // this.props.setDrillHandle({property: newPropertyLabel, breakup: null, include: objBreak.SelectedBreakUp, point: null, period: period, startDate: startDate, endDate: endDate, includeDisp: objBreak.SelectedBreakUpDisp})
                } else if (this.props.pageName === 'pinboard' && allCurrentValues && allCurrentValues.chart) {
                    let url = window.location.origin + `/chart/chartData?property=${encodeURIComponent(type.value)}&metric=${encodeURIComponent(selectedMetric)}&startDate=${encodeURIComponent(startDate)}&endDate=${encodeURIComponent(endDate)}&chartCat=${dateSelected ? chartCat : allCurrentValues.chartDisp}&include=${encodeURIComponent(allCurrentValues.breakUp)}&multiDim=true}`
                    let win = window.open(url, '_blank');
                    win.focus();
                } else {
                    // this.props.setDrillHandle({property: type.value, breakup: null, include: this.state.SelectedBreakUp, point: null, period: period, startDate: startDate, endDate: endDate, includeDisp: this.state.SelectedBreakUpDisp})
                    var objData = { property: type.value, breakup: null, include: this.state.SelectedBreakUp, point: null, insightPoint: null, insight: null, deepInsight: null, period: period, startDate: startDate, endDate: endDate, includeDisp: this.state.SelectedBreakUpDisp, chartCat: chartCat }
                    let finalObj = handleParamsToSet({ include: null, exclude: null, filter: null, property: null }, objData, this)
                    this.props.set_disp_objects({ ...finalObj });
                }
            }
        }
    }
    handleClick = () => {
        if (this.state.open) {
            this.setState({
                open: false
            })
        } else {
            this.setState({
                open: true
            })
        }
    }
    filterHandleChange(jsonData) {
        this.handleChange({ ...jsonData, renderDataStatus: true });
    }
    handleChange(new_props) {
        if (!handleChangeCalled && !(new_props.initialDataApiFlag || this.props.initialDataApiFlag)) {
            if ((localStorage.Dataset && JSON.parse(localStorage.Dataset).toolId) && (new_props.renderDataStatus || metricGlobal.length == 0)) {
                if (this.props.property != new_props.property || this.props.breakup != new_props.breakup || this.props.include != new_props.include || this.props.exclude != new_props.exclude || this.props.period != new_props.period || this.props.selectedMetric != new_props.selectedMetric || new_props.renderDataStatus || metricGlobal.length == 0) {

                    var dataset = JSON.parse(localStorage.Dataset);
                    var that = this;
                    var userId = this.props.authData ? this.props.authData.userId : null;
                    var authorization_value = null;
                    authorization_value = "Basic " + btoa(userId + ":");
                    handleChangeCalled = true

                    let params = { propValues: new_props.property, filterValues: new_props.breakup, include: new_props.include, exclude: new_props.exclude, siteId: dataset.siteId, toolId: this.props.dataSet.toolId, filterType: "all" }
                    // let postData = { userId: userId }
                    let postData = null

                    CallAPI('get', '/app/initialData', postData, params, 0, function (response) {
                        // if (response.status === 500 || response.status === 503 || response.status === 504) {
                        //     if (counter <= 2) {
                        //         handleChangeCalled = false;
                        //         that.handleChange(new_props);
                        //         counter++;
                        //     } else {
                        //         handleChangeCalled = false;
                        //         alert(`${error.response.status}: Server Error, please try again later`);
                        //     }
                        // } else {
                            handleChangeCalled = false
                            if (new_props.location && window.location.pathname == '/summary' && new_props.location.pathname != window.location.pathname) {
                                new_props.property = 'null'
                            }
                            let finalObj = handleParamsToSet(response, new_props, that);
                            that.props.set_disp_objects({ ...finalObj, 'initialDataApiFlag': true });
                        // }
                    }, this.props.authData)

                    /* Commented below axios api call & changes it to above CallAPI method */
                    // axios({
                    //     method: 'post',
                    //     url: '/app/initialData',
                    //     data: { propValues: new_props.property, filterValues: new_props.breakup, include: new_props.include, exclude: new_props.exclude, siteId: dataset.siteId, toolId: dataset.toolId, filterType: "all", userId: userId },
                    //     headers: { Authorization: authorization_value }
                    // }).then(response => {
                    //     handleChangeCalled = false
                    //     response = response.data;
                    //     // Anurag Update on Total dimension (Start)
                    //     if (new_props.location && window.location.pathname == '/summary' && new_props.location.pathname != window.location.pathname) {
                    //         new_props.property = 'null'
                    //     }
                    //     // if ((new_props.clicked).includes('property') && (new_props.property == 'empty' || !new_props.property || new_props.property == "null")) {
                    //     //     let type = [{
                    //     //         label: 'Total',
                    //     //         value: 'all',
                    //     //         type: "propertyLabel"
                    //     //     }];
                    //     //     response.property = JSON.stringify(type);
                    //     //     new_props.property = 'empty'
                    //     // }
                    //     // Anurag Update on Total dimension (End)
                    //     // var propertyDisp = [];
                    //     // var SelectedBreakUpDisp = [];
                    //     // if (new_props.property) {
                    //     //     response.propertyDisp = JSON.parse(response.property);
                    //     // }
                    //     // if (new_props.breakup && new_props.breakup.length!=0) {
                    //     //     response.SelectedBreakUpDisp = JSON.parse(response.filter);
                    //     // }
                    //     // that.setState({
                    //     //     ...new_props,
                    //     //     propertyDisp: propertyDisp,
                    //     //     SelectedBreakUpDisp: SelectedBreakUpDisp,
                    //     //     includeDisp: JSON.parse(response.include),
                    //     //     excludeDisp: JSON.parse(response.exclude),
                    //     // })
                    //     // if(new_props.transpose === false && new_props.crosstab_flag === true) {
                    //     //     this.props.setTableActions({ crosstab_flag: true, transpose: false })
                    //     // } else if (new_props.transpose === "" && new_props.crosstab_flag === false){
                    //     //     this.props.setTableActions({ crosstab_flag: false })
                    //     // }
                    //     // if(new_props.saveFilterToggle !== undefined && new_props.saveFilterToggle !== null) {
                    //     //     this.props.saveFilterToggleHandle(new_props.saveFilterToggle)
                    //     // }
                    //     let finalObj = handleParamsToSet(response, new_props, that);
                    //     that.props.set_disp_objects({ ...finalObj, 'initialDataApiFlag': true });
                    //     // that.props.set_disp_objects({ ...new_props,"propertyDisp": propertyDisp, "breakupDisp": SelectedBreakUpDisp, "metricDisp": selectedMetricDisp, includeDisp: JSON.parse(response.include), excludeDisp: JSON.parse(response.exclude), "metricGlobal":response.metric,"metricFunction":response.metricFunction,"metric":new_props.selectedMetric })
                    // }).catch(error => {
                    //     if (error.response.status === 500 || error.response.status === 503 || error.response.status === 504) {
                    //         if (counter <= 2) {
                    //             handleChangeCalled = false;
                    //             that.handleChange(new_props);
                    //             counter++;
                    //         } else {
                    //             handleChangeCalled = false;
                    //             alert(`${error.response.status}: Server Error, please try again later`);
                    //         }
                    //     } else {
                    //         handleChangeCalled = false;
                    //         alert(`${error.response.status}: Server Error, please try again later`);
                    //     }
                    // });
                }
            }
        }
    }
    buildMenu(userFeature, dashbordGroups, period, notification) {
        // userType=0 - no access
        // userType=1 - admin access
        // userType=3 - read access
         if(this?.props?.dataSet?.userType!=1){
            userFeature = userFeature?.filter((value)=>{
                return value.toLowerCase() != "settings";
            })
        }
        // if(this?.props?.dataSet?.userType!=1){
            // userFeature = userFeature?.filter((value)=>{
            //     return value.toLowerCase() != "settings";
            // })
        // }
        let dbSetting = localStorage['persist:root'] ? JSON.parse(JSON.parse(localStorage['persist:root'])['dataSet']).userDBSetting : null
        let prop = 'null'
        var crosstabProp = '/report?nav=new'
        if (dbSetting) {
            if (dbSetting[0]['defaultProperty']) {
                prop = dbSetting[0]['defaultProperty'].split(',')
                prop = `${prop[0]}` + (prop[1] ? `,${prop[1]}` : '')
            }
            crosstabProp += `&property=${prop}&multiDim=false&transpose=false&kpiMonitoring=false&period=Aggregate`
        }
       
        period = period && period != 'Aggregate' ? period : "Month"
        var menuOptions = {};
        // userFeature = window.location.pathname.substring(1) === startPage ? null : userFeature        // if(userFeature) {
            if(this.props.allDashboards && this.props.allDashboards.dashbordGroups){
                let globalDashboardGroupList = {}
                var searchString = 'globaldashboard'; 
                // if(checkInArrayCaseInsensitive(userFeature, searchString)) {
                    // this.props.allDashboards.dashbordGroups.map(function(innerData){
                    //     if(innerData['type']=="global")
                    //         globalDashboardGroupList[innerData['dashboard_group']] = { "name": innerData['dashboard_group'], "label": innerData['dashboard_group'], "link": `/globaldashboards/${innerData['dashboard_group']}?group=${innerData['dashboard_group']}&property=null&nav=new` };
                    // })
                    // if(Object.keys(globalDashboardGroupList).length>0){
                    //     menuOptions["globalDashboard"] = {
                    //         "name": "globalDashboard", "label": "Global Dashboard", "link": "/globaldashboards", "icon": "grid", "showMenu": false,
                    //         children: globalDashboardGroupList
                    //     }
                    // }
                // }

                // searchString = 'alldashboards';
                // if(checkInArrayCaseInsensitive(userFeature, searchString)) {
                    // menuOptions["allDashboards"] = { "name": "allDashboards", "label": 'List All Dashboards', "link": "/alldashboards", "icon": "list", "showMenu": false }
                // }                
            }   
        // }

        
        menuOptions["dataset"] = {
                "name": "dataset", "label": 'Datasets', "link": "/start", "icon": "database",
            //     "children": {  
            //         "dataset": { "name": "dataset", "label": "Datasets", "link": "/start", "showMenu": false, },
            //         // "dashboards": { "name": "dashboards", "label": "Dashboards", "link": "/start?tab=dashboards", "showMenu": false },
            //         // "reports": { "name": "reports", "label": "Reports", "link": "/start?tab=reports", "showMenu": false },
             
            // }
        }
        
        if (userFeature && localStorage.Dataset) {
            var alldashbordGroups = {};
            alldashbordGroups['default'] = { "name": "default", "label": "default", "link": "/pinboard/default?group=default&property=null&nav=new" };
            if (dashbordGroups) {
                alldashbordGroups = {};
                for (var i = 0; i < dashbordGroups.length; i++) {
                    const innerData = `${dashbordGroups[i]['dashboard_group']}`;
                    if(dashbordGroups[i]['type']=="local")
                        alldashbordGroups[innerData] = { "name": innerData, "label": innerData, "link": `/pinboard/${innerData}?group=${innerData}&property=null&nav=new` };
                }
            }
            
            userFeature.map(function (innerData) {
                let optionObj = {};
                let key = null;
                let featureName = innerData.featureName ? innerData.featureName : innerData 
                switch (featureName.toLowerCase()) {
                 
                    case "alfred":
                        optionObj = { "name": "alfred", "label": "Search", "link": "/alfred", "icon": "search", "showMenu": false };
                        key = "alfred";
                        break;
                    // case "summary":
                    //     optionObj = { "name": "summary", "label": "Summary", "link": "/summary?property=null&nav=new", "icon": "monitor", "showMenu": false };
                    //     key = "summary";
                    //     break;
                    case "dashboard":
                        menuOptions["dashboard"] = {
                            "name": "dashboard", "label": "Dashboards", "link": "/start?tab=dashboards", "icon": "grid", "showMenu": false,
                            // children: alldashbordGroups
                        };
                        break;
                    case "chart":                                            
                        optionObj = {
                            "name": "chart", "label": "Visuals", "link": "/chart", "icon": "bar-chart", "showMenu": false,
                            // children: {
                            //     "allCharts": { name: "allCharts", label: "All Charts", link: "/chart", icon: "", showMenu: true },
                            //     "line": { name: "line", label: "Line", link: `/chart/chartData/line?property=null&chartCat=Line&nav=new`, icon: "", showMenu: true },
                            //     "area": { name: "area", label: "Area", link: `/chart/chartData/area?chartCat=Area&nav=new`, icon: "", showMenu: true },
                            //     "bar": { name: "bar", label: "Bar", link: "/chart/chartData/bar?chartCat=Bar&nav=new", icon: "", showMenu: true },
                            //     "barBullet": { name: "barBullet", label: "Bar Bullet", link: "/chart/chartData/barbullet?chartCat=Bar Bullet&nav=new", icon: "", showMenu: true },
                            //     "column": { name: "column", label: "Column", link: "/chart/chartData/column?chartCat=Column&nav=new", icon: "", showMenu: true },
                            //     "bullet": { name: "bullet", label: "Bullet", link: "/chart/chartData/bullet?chartCat=Bullet&nav=new", icon: "", showMenu: true },
                            //     "pie": { name: "pie", label: "Pie", link: "/chart/chartData/pie?chartCat=Pie&nav=new", icon: "", showMenu: true },
                            //     "scatter": { name: "scatter", label: "Scatter", link: "/chart/chartData/scatter?chartCat=Scatter&nav=new", icon: "", showMenu: true },
                            //     "bubble": { name: "bubble", label: "Bubble", link: "/chart/chartData/bubble?chartCat=Bubble&nav=new", icon: "", showMenu: true },
                            // }
                        };
                        key = "chart";
                        break;
                    case "report":
                    case "table":
                        optionObj = {
                            "name": "report", "label": "Tables", "link": "/report?nav=new&period=Aggregate", "icon": "server", "showMenu": false,
                            children: {
                                "standard": { name: "standard", label: "Standard", link: "/report?nav=new&period=Aggregate", icon: "", showMenu: true },
                                "tableTrend": { name: "tableTrend", label: "Trend", link: `/report?period=${period}&nav=new`, icon: "", showMenu: true },
                                "crossTab": { name: "crossTab", label: "Crosstab", link: `${crosstabProp}`, icon: "", showMenu: true },
                                "transposeTable": { name: "transposeTable", label: "Transpose", link: "/report?transpose=true&period=Aggregate&nav=new", icon: "", showMenu: true },
                                "kpiMonitoring": { name: "kpiMonitoring", label: "KPI Monitoring", link: "/report?property=null&kpiMonitoring=true&period=Aggregate&nav=new", icon: "", showMenu: true }
                            }
                        };
                        key = "report";
                        // menuOptions["savedReport"] = { name: "savedReport", "label": "Saved Report", "link": "/report/SavedReport", "icon": "pocket", showMenu: true }
                        break;
                }
                if (key) {
                    menuOptions[key] = optionObj;
                    // if(key === "report") {
                    //     if(checkIfFeatureApplicable('Saved Report', userFeature)) 
                    //         menuOptions["savedReport"] = { name: "savedReport", "label": "Saved Reports", "link": "/report/SavedReport", "icon": "pocket", showMenu: true }
                    // }
                }                    
            })
            // menuOptions = {
            //     "search": { "name": "search", "label": 'Alfred', "link": "/alfred", "icon": "search", "showMenu": false  },
            //     "summary": { "name": "summary", "label": 'Summary', "link": "/summary", "icon": "monitor", "showMenu": false  },
            //     "chart": { "name": "chart", "label": 'Charts', "link": "/chart", "icon": "bar-chart", "showMenu": false  },
            //     "report": { "name": "report", "label": 'Reports', "link": "/report", "icon": "server", "showMenu": false  },
            //     "dataset": { "name": "dataset", "label": 'Datasets', "link": "/start", "icon": "database", "showMenu": false  }
            // };
        }

        if(userFeature)
            menuOptions["apiRequest"] = { "name": "apiRequest", "label": 'Request Logs', "link": "/requestLogs/app", "icon": "activity", "showMenu": false }
        
        // if(JSON.parse(localStorage.Dataset).toolId){
        //     menuOptions["dataset"].children = {...menuOptions["dataset"].children , "dashboards": { "name": "dashboards", "label": "Dashboards", "link": "/start?tab=dashboards", "showMenu": false }}
        // }
        if (notification && Object.keys(notification).length) {
            // menuOptions["notification"] = { "name": "notification", "label": 'Notification', "link": "/notification", "icon": "bell", "showMenu": false }
        }
        // menuOptions["dataset"] = { "name": "dataset", "label": 'Datasets', "link": "/start", "icon": "database", "showMenu": false }
        if(this.props.dataSet.userType=="1"){
            // menuOptions["setting"] = { "name": "setting", "label": 'Settings', "link": "/setting", "icon": "settings", "showMenu": false }
            menuOptions["adminPanel"] = { "name": "adminPanel", "label": 'Admin Panel', "link": "/admin", "icon": "unlock", "showMenu": false }            
            // menuOptions["dashboard"] ? menuOptions["dashboard"]['children']['List'] = { "name": "list", "label": "List", "link": "/start?tab=dashboards" } : null;
        } 
        // else if(localStorage['persist:root'] && JSON.parse(JSON.parse(localStorage['persist:root']).dataSet).dataResult.length==0){
        //     menuOptions["adminPanel"] = { "name": "adminPanel", "label": 'Admin Panel', "link": "/admin", "icon": "unlock", "showMenu": false }
        // }
        return menuOptions;
    }

    // Comment
    checkSession() {
        const that = this;
        var authData = this.props.authData;
        const currentTime = Math.round(new Date().getTime() / 1000);
        if (authData !== null) {
            if (authData.expiry < currentTime) {
                if (authData.refresh_token !== null) {

                    const data = {
                        refreshToken: authData.refresh_token,
                        companyName: authData.companyName
                    };

                    const params = {
                        auth: "system"
                    };

                    const url = "/oidc/refreshToken";
                    CallAPI('POST', url, data, params, 0, function (response) {
                        if (response.Code == '204') {
                            authData.expiry = response.expr;
                            authData.access_token = response.access_token;
                            authData.refresh_token = response.refresh_token;
                            that.props.setAuthData(authData);
                            that.props.history.push('/');

                        }
                        else if (response.Code == '400') {
                            console.log(response.status);
                            that.props.history.push('/workspace');
                        }
                    });
                }
                else {
                    that.props.history.push('/workspace');
                }
            }
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            pageError: true
        })
    }

    setTitle() {
        var pathName = location.pathname;
        pathName = pathName.split("/");

        if (pathName.length == 4)
            pathName = pathName[2];
        else pathName = pathName[pathName.length - 1];

        let title = "";
        let page = "";
        let chartType = "";
        switch (pathName) {
            case "report":
                title = "Table"
                break;
            case "pinboard":
                title = "Dashboard"
                break;
            case "chartData":
                chartType = decodeURI((getParametersFromString("chartCat", window.location.search)));
                title = `${chartType} Chart`
                page = `Chart`
                break;
            case "summary":
                title = `Summary`
                break;
            case "alfred":
                title = `Search`
                break;
            case "oops":
                title = `Oops!`
                break;
            case "insight":
                title = `Insight`
                break;
            case "deepInsight":
            case "deepinsight":
                title = `Root Cause Analysis`
            case "chart":
                title = `Visuals`
                break;
            case "notification":
                title = `Notification`
                break;
            case "":
            case "dataset":
            case "start":
                title = "Dataset"
                break;
            case "setting":
                title = "Settings"
                break;
            case "alldashboards":
                title = "All Dashboards"
                break;
            case "globaldashboards":
                title = "Global Dashboards"
                break;
            case "app":
                title = "Request Logs"
                break;
            case "SavedReport":
                title = "Saved Reports"
                break;
        }

        if (title && document.title != title) {
            this.saveAPILog(page ? page : title, chartType);
        }

        document.title = `${title} | Cognitive Analytics Platform`;
    }

    saveAPILog(pageName, chartType) {
        if(pageName !== 'Dashboard'){
            var questionAsked = this.props.alfred_question ? this.props.alfred_question : window.location.href;
            var visitedTime = moment().format('YYYY-MM-DD HH:mm:ss');
    
            let postLogDataNew = { "page": pageName, "userId": this.props.authData.userId, "visitedTime": visitedTime, "name": `${this.props.authData.firstName} ${this.props.authData.lastName}`, "questionType": chartType, "questionAsked": questionAsked, "toolId": this.props.dataSet.toolId, "siteId": this.props.dataSet.siteId, "email": this.props.authData.username, "dataSet": this.props.dataSet.name, "companyName": this.props.authData.companyName };
    
            if (JSON.stringify(postLogData) != JSON.stringify(postLogDataNew)) {
                // postLogDataNew = encodePostBody(postLogDataNew)
                CallAPI('POST', "/app/system/user_activity_log", postLogDataNew, { auth: "system" }, 0, function (response) {
                    if (response.Code == '204') {
    
                    }
                }, this.props.authData);
            }


            // axios.post("/app/system/user_activity_log",{
            //     headers: { Authorization: authorization_value},
            //     data: postData
            // }).then(response=>{
            //     
            // });
        }
    }

    handleAlrfedQuestionNewTab = (alfred_question, redirect) => {
        var dataset = JSON.parse(localStorage.Dataset);
        var voice = 0;
        let userId = null
        let sessionId = null
        if (this.props.authData) {
            userId = this.props.authData.userId
            sessionId = encodePassword(this.props.authData.sessionId)
        }
        
        var authorization_value = "Basic " + btoa(encodePassword(userId) + ":");

        var that = this;
        jQuery.ajax({
            type: 'get',
            // url: `/app/alfred?toolId=${dataset.toolId}&siteId=${dataset.siteId}&userId=${userId}&query=${alfred_question}&type=dashboard&voice=${voice}`,
            url: `/app/alfred?toolId=${dataset.toolId}&siteId=${dataset.siteId}&query=${alfred_question}&type=dashboard&voice=${voice}`,
            headers: { Authorization: authorization_value, sessionId: sessionId },
            success: function (alfredResponse) {
                alfredResponse = decodeResponseBody(alfredResponse)
                checkIfSessionTimedOut(alfredResponse)
                checkIfMaintenanceModeOn(alfredResponse)
                var urlArray = [];
                urlArray['url'] = `${alfredResponse['url']}&suggestedQuestion=${alfredResponse['suggestedQuestion']}&questionId=${alfredResponse['lastId']}`;
                urlArray['questionId'] = `${alfredResponse['lastId']}`;

                let response = urlArray['url']
                // let url = urlArray['url'].replace("DASHBOARD_URL",'',urlArray['url']);                    
                let dashboard_url = response.split('/')
                response = response.replace('dashboard/', '')
                response = response.replace('charttype?', 'chart/chartData?')
                response = response.replace(dashboard_url[0], window.location.origin)
                let parser = document.createElement('a');
                parser.href = response;
                // var url = response.replace(parser.host, '');
                let url = response;
                url = url.replace('%27', '%20');
                // window.open(url, '_blank');
                window.open(url, "_self");
                return urlArray;
            }
        });
    }

    changeDataSet(newToolId,datasetChange) {
        if (newToolId) {
            var that = this, actual_data = {};
            if (typeof newToolId == 'string') {
                this.props.dataResult.map(function (innerData) {
                    if (innerData.toolId == newToolId)
                        actual_data = innerData;
                })
            } else actual_data = newToolId
            let params = {
                siteId: actual_data.siteId,
                toolId: actual_data.toolId,
                filterType: 'all',
                propValues: null,
                filterValues: null,
                type: null
            }
            let postData = { userId: this.props.authData.userId }
            CallAPI("POST", '/app/initialRequest', postData, params, 0, function (res) {
                checkIfSessionTimedOut(res)
                checkIfMaintenanceModeOn(res)
                var userFeature = getUpdatedUserFeature(res.userFeature);
                var dateObject = res.dateTime[0];
                var final_data = {
                    ...actual_data,
                    endDate: dateObject.dashboardEndTime,
                    startDate: dateObject.dashboardStartTime,
                    endTime: dateObject.endTime,
                    startTime: dateObject.startTime,
                    userFeature: userFeature,
                    dashbordGroupsNames: res.dashboardGroupsName,
                    dashbordGroups: res.dashbordGroups,
                    userDBSetting: res.userDBSetting,
                    summarizationDetails: res.summarizationDetails,
                    getAllUsers: res.getAllUsers,
                    getNotification: res.getNotification,
                    getuserprofile: res.getuserprofile,
                    chartDefault: res.chartDefault,
                    alfredChartFlag:false,
                    datasetChange: datasetChange ? datasetChange : false,
                    alfred: { intent: res.intent, metric: res.metric, property: res.property, questions: res.questions, location: res.location, chart_array: res.chart },
                    kpiMonitoringFunctions: res.kpiMonitoringFunctions,
                   
                }
                that.props.setData(final_data)
                that.props.handle_restricted_Filter({ restrictedFilter: res.restrictedFilter })
                let global_filter = res.globalFilter[0] && res.globalFilter[0].temporary_filter && isJson(res.globalFilter[0].temporary_filter) ? JSON.parse(res.globalFilter[0].temporary_filter) : []
                that.props.setGlobalFilters(global_filter)
                let defaultFunctions = []
                res.defaultKPIMonitoringFunctions && res.defaultKPIMonitoringFunctions.map((innerData) => {
                    defaultFunctions.push(innerData.value)
                })
                let selectedKpiColumn = []
                selectedKpiColumn = getParameters('kpiColumnConfig') ? getParameters('kpiColumnConfig').includes(',') ?
                    getParameters('kpiColumnConfig').split(",") : getParameters('kpiColumnConfig').split("%2C") : [];
                that.props.setKpiColumnConfig(getParameters('kpiColumnConfig') ? selectedKpiColumn : defaultFunctions)
                window.localStorage.setItem('Dataset', JSON.stringify(actual_data));
                window.localStorage.setItem('dashboardConfigKey', {});
                // let dashboardID = typeof newToolId == 'string' ? that.props.id_dashboard : final_data.dashbordGroups[0].idDashboard
                that.props.history.push(`/landingPage?dashboard_id=${that.props.id_dashboard}`);
            }, this.props.authData)
        }
    }

    getOpenStatus = () => this.state.currentPageName === "insight" || this.state.currentPageName === "deepinsight";
    handleLoadingStatus(value){
        this.setState({
            loading:value
        })
    }
    render() {
        drillHandleFunction = this.drillHandle;
        filterHandleChangeFunction = this.filterHandleChange;
        changeDatasetFunction = this.changeDataSet;

        // var authData = this.props.authData;
        var authData = localStorage['persist:root'] && JSON.parse(localStorage['persist:root'])['dataSet'] ?  JSON.parse(JSON.parse(localStorage['persist:root'])['dataSet'])['authData'] : this.props.authData
        if (!authData || !authData.userId) {
            return (
                <Redirect to="/login" />
            )
        }
        
        if(this.props.newToolId && this.props.dataSet.toolId != this.props.newToolId){
        // if(this.props.newToolId){
            window.localStorage.setItem('redirectTo', JSON.stringify(location));
            this.changeDataSet(this.props.newToolId);
            return null;
        }

        var url = new URL(location.href); //window.location.href           
        var chartCat = url.searchParams.get("chartCat");

        var timeseriesPeriod = this.props.period
        let notification = this.props.dataSet.getNotification ? this.props.dataSet.getNotification['result'] : null; 
        menu_array = this.buildMenu(this.props.userFeature ? this.props.userFeature['dash_nav'] : [], this.props.dashbordGroups, timeseriesPeriod, notification);
        this.setTitle();

        if (this.props.currentPageName === 'query' && this.props.alfred_question) {
            this.handleAlrfedQuestionNewTab(this.props.alfred_question, true);
        }

        if (location.pathname == "/landingPage" && Object.keys(this.props.dataSet).length && this.props.dataSet.toolId == JSON.parse(localStorage.Dataset).toolId && this.props.dataSet.userDBSetting && this.props.startDate) {
            
            let landingPage = this.props.dataSet.userDBSetting ? this.props.dataSet.userDBSetting[0].defaullt_landing_page : "alfred";
            if(this.props.id_dashboard){
                landingPage = `pinboard?dashboard_id=${this.props.id_dashboard}`;
            }else{
                if (landingPage == "dashboard") {
                    landingPage = "start?tab=dashboards"
                    // if (this.props.dataSet.dashbordGroups) {
                    //     let dashGroup = 'Default'
                    //     if (this.props.dataSet.dashbordGroups[0]) {
                    //         dashGroup = this.props.dataSet.dashbordGroups[0]['dashboard_group']
                    //         id_dashboard = this.props.dataSet.dashbordGroups[0]['idDashboard']
                    //     }
                    //     landingPage += `/${dashGroup}?property=null&nav=new`
                    // }
                } else {
                    landingPage = landingPage == 'summary' ? `${landingPage}?nav=new&property=null` : `${landingPage}?nav=new`
                }
            }
            // let landingPage = this.props.dataSet.userDBSetting ? this.props.dataSet.userDBSetting[0].defaullt_landing_page : "alfred";
            // landingPage = landingPage == "dashboard" ? "pinboard" : landingPage;
            
            if (!handleChangeCalled) {
                if(localStorage.getItem('redirectTo') && JSON.parse(localStorage.getItem('redirectTo')).pathname !== '/alfred'){
                    landingPage = `${JSON.parse(localStorage.getItem('redirectTo')).pathname}${JSON.parse(localStorage.getItem('redirectTo')).search}`.substring(1);
                    landingPage += `&toolId=${this.props.dataSet.toolId}`;
                    window.localStorage.removeItem("redirectTo");
    
                }
                location.href = `/${landingPage}`;
            }
            // setTimeout(() => {
            //     location.href = `/${landingPage}`;
            // }, 500);
            // return (
            //     <Redirect to={`/${landingPage}`} />
            // )
        }
        var topStyle = { margin: '21px 0px -8px 22px' };
        var periodComparison = "";
        var growthPeriod = null;
        let filter_component = null;

        // let propertyMain = { label: 'Total', value: 'all', type: "propertyLabel" };
        metricGlobal = this.props.metricGlobal;
        metricFunction = this.props.metricFunction;

        let selectedMetricDisp=[]
        if (this.props.selectedMetric && this.props.selectedMetric.length > 0) {
            selectedMetricDisp = metricDataToDisp(this.props.metricGlobal, this.props.metricFunction, this.props.selectedMetric);
        }

        if (this.props.granularity == "date" || this.props.granularity == "day")
            TimeType = [
                { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }, { label: 'Quarter', value: 'Quarter' }, { label: 'Month', value: 'Month' }, { label: 'Week', value: 'Week' }, { label: 'Day Name', value: 'dayname' }, { label: 'Day', value: 'Day' }
            ];
        else if (this.props.granularity == "week")
            TimeType = [
                { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }, { label: 'Quarter', value: 'Quarter' }, { label: 'Month', value: 'Month' }, { label: 'Week', value: 'Week' }
            ];
        else if (this.props.granularity == "hour")
            TimeType = [
                { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }, { label: 'Quarter', value: 'Quarter' }, { label: 'Month', value: 'Month' }, { label: 'Week', value: 'Week' }, { label: 'Day Name', value: 'dayname' }, { label: 'Day', value: 'Day' }, { label: 'Hour', value: 'Hour' }
            ];
        else if (this.props.granularity == "week")
                TimeType = [
                    { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }, { label: 'Quarter', value: 'Quarter' }, { label: 'Month', value: 'Month' }, { label: 'Week', value: 'Week' }
                ];
        else if (this.props.granularity == "month")
            TimeType = [
                { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }, { label: 'Quarter', value: 'Quarter' }, { label: 'Month', value: 'Month' }
            ];
        else if (this.props.granularity == "quarter")
            TimeType = [
                { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }, { label: 'Quarter', value: 'Quarter' }
            ];
        else if (this.props.granularity == "year")
            TimeType = [
                { label: 'Aggregate', value: 'Aggregate' }, { label: 'Year', value: 'Year' }
            ];

        var top_filters = ['summary', 'chartData', 'report', 'dashboard', 'alfred','globaldashboards'];

        var filter_pages = ['summary', 'chartData', 'report', 'pinboard'];

        var enable_filter = false;
        var enable_top_filter = false;

        var temp_url = location.pathname.split('/');

        if (temp_url.length == 4)
            temp_url = temp_url[2];
        else if (temp_url[1] == "pinboard" || temp_url[1] == "globaldashboards")
            temp_url = temp_url[1];
        else temp_url = temp_url[temp_url.length - 1];

        if (filter_pages.indexOf(temp_url) != -1) {
            enable_filter = true;
        }

        if (top_filters.indexOf(temp_url) != -1) {
            enable_top_filter = true;
        }

        if (temp_url == "chart" || temp_url == "chartData")
            temp_url = "charts";

        minDateCalendar = this.props.dataset_info.dataSet.startTime;
        maxDateCalendar = this.props.dataset_info.dataSet.endTime;

        var descriptionComponentVariable = null
        var filter_open_body = {};

        // if (defaultFilterFlag == '1' && enable_filter && (!this.props.insight && !this.props.deepInsight && (!this.state.insightPoint || this.state.insightPoint == "null"))) {
        // Removed insightpoint condition as it was giving issue to open filter after insight
        if (defaultFilterFlag == '1' && enable_filter && (!this.props.insight && !this.props.deepInsight)) {
            if (jQuery(window).width() >= mobile_width) {
                var filter_open_body = { marginRight: "382px" };
            }

            if (this.props.pageName == "report") {
                if (this.props.propertyDisp && this.props.propertyDisp.length > 5) {   // Hide time granularity when there are more than 5 dimensions
                    TimeType = [{ label: 'Aggregate', value: '' }];
                    chartCat = chartCat ? chartCat : this.props.pageName
                }
            }

            const filterProps = {
                ref: 'sidebarInsightRef',
                authData: this.props.authData,
                propertyDisp: this.props.propertyDisp,
                property: this.props.property,
                breakup: this.props.breakup,
                SelectedBreakUpDisp: this.props.SelectedBreakUpDisp,
                include: this.props.include,
                includeDisp: this.props.includeDisp,
                exclude: this.props.exclude,
                excludeDisp: this.props.excludeDisp,
                selectedMetric: this.props.selectedMetric,
                Metric: this.props.metricGlobal,
                startDate: this.state.startDate,
                chartType: this.props.period,
                endDate: this.state.endDate,
                filterHandleChange: this.filterHandleChange,
                startDateDisp: this.state.startDateDisp,
                endDateDisp: this.state.endDateDisp,
                metricFunction: this.props.metricFunction,
                datasetDetails: this.props.dataset_info.dataSet,
                period: this.props.period,
                transpose: this.props.transpose,
                kpiMonitoring: this.props.kpiMonitoring,
                propMulti: false,
                selectedMetricDisp: selectedMetricDisp,
                metricMulti: true,
                pageName: this.props.pageName,
                TimeType: TimeType,
                insightPoint: this.props.insightPoint,
                insightType: this.state.insightType,
                insightMetric: this.state.insightMetric,
                periodComparison: periodComparison,
                outputType: this.state.outputType,
                growthPeriod: growthPeriod,
                chartCat: chartCat,
                property_multi_flag: this.props.property_multi,
                propMulti: this.props.propMulti,
                crosstab_flag: this.props.crosstab_flag,
                enable_multi_dimension_title: this.props.enable_multi_dimension_title,
                enable_crosstab_title: this.props.enable_crosstab_title,
                dashboardConfigDates: this.props.dashboardConfigDates,
                enablePageDescription: this.enablePageDescription,
                sortOrder: this.props.sortOrder,
                limit: this.props.limit,
                alfred_question: alfredConfig == 'yes' ? this.props.alfred_question : "",
                changeDataSet: this.changeDataSet
            }

            filter_component = this.props.oldFilter ? <OldFilterComponent {...filterProps} /> :  <FilterComponent {...filterProps} />;

        } else if ((this.props.insight || this.props.deepInsight) && this.state.insightPoint) {
            if (jQuery(window).width() >= mobile_width) {
                // var filter_open_body = { marginRight: "386px" };                
                var filter_open_body = { marginRight: "500px" };                
            }

            let currentPageName = this.props.currentPageName
            let insight_selectedMetricDisp = this.props.selectedMetricDisp
            let insight_period = this.props.period
            let insight_property = this.props.property
            let insight_propertyDisp = this.state.propertyDisp
            let insight_breakup = this.props.breakup
            insight_breakup = typeof insight_breakup === 'function' ? '' : insight_breakup
            let insight_SelectedBreakUpDisp = this.state.SelectedBreakUpDisp
            let insight_selectedMetric = this.props.selectedMetric
            let insight_chartCat = this.props.chartCat
            let insight_include = this.props.include
            let insight_includeDisp = this.props.includeDisp
            let insight_exclude = this.props.exclude
            let insight_excludeDisp = this.props.excludeDisp
            let insight_componentData = this.props.componentData
            let insight_startDate = this.props.startDate
            let insight_endDate = this.props.endDate

            if(insight_chartCat != 'report') {
                if(insight_componentData && insight_componentData.data) {
                    insight_include = insight_componentData.data.parameter_cache.category.includeBreakUp ? insight_componentData.data.parameter_cache.category.includeBreakUp : insight_include
                    insight_includeDisp = insight_componentData.includeDisp ? insight_componentData.includeDisp : insight_includeDisp
                    insight_exclude = insight_componentData.data.parameter_cache.category.excludeBreakUp ? insight_componentData.data.parameter_cache.category.excludeBreakUp : insight_exclude
                    insight_excludeDisp = insight_componentData.excludeDisp ? insight_componentData.excludeDisp : insight_excludeDisp
                    insight_startDate = insight_componentData.data.parameter_cache.date.startDate ? insight_componentData.data.parameter_cache.date.startDate : insight_startDate
                    insight_endDate = insight_componentData.data.parameter_cache.date.endDate ? insight_componentData.data.parameter_cache.date.endDate : insight_endDate
                }
                
            }                
            let insight_periodComparison = periodComparison
            let insight_dashboardConfig = this.props.dashboardConfig
            let insight_chartType = this.props.chartType
            let insight_metricRange = this.state.metricRange            

            if(currentPageName == 'pinboard' || currentPageName == 'insight') {
                if(insight_componentData) {
                    insight_selectedMetricDisp = insight_componentData.selectedMetricDisp ? insight_componentData.selectedMetricDisp : insight_selectedMetricDisp
                    insight_period = insight_componentData.period ? insight_componentData.period : insight_period
                    insight_property = insight_componentData.property ? insight_componentData.property : insight_property
                    insight_propertyDisp = insight_componentData.propertyDisp ? insight_componentData.propertyDisp : insight_propertyDisp
                    insight_breakup = insight_componentData.breakup ? insight_componentData.breakup : insight_breakup
                    insight_SelectedBreakUpDisp = insight_componentData.SelectedBreakUpDisp ? insight_componentData.SelectedBreakUpDisp : insight_SelectedBreakUpDisp
                    insight_selectedMetric = insight_componentData.selectedMetric ? insight_componentData.selectedMetric : insight_selectedMetric
                    // Handle include and exclude in chart
                    insight_include = insight_componentData.include ? insight_componentData.include : insight_include
                    insight_includeDisp = insight_componentData.includeDisp ? insight_componentData.includeDisp : insight_includeDisp
                    insight_exclude = insight_componentData.exclude ? insight_componentData.exclude : insight_exclude
                    insight_excludeDisp = insight_componentData.excludeDisp ? insight_componentData.excludeDisp : insight_excludeDisp
                    insight_startDate = insight_componentData.startDate ? insight_componentData.startDate : insight_startDate
                    insight_endDate = insight_componentData.endDate ? insight_componentData.endDate : insight_endDate

                    if(insight_chartCat != 'report') {
                        if(insight_componentData.data) {
                            insight_include = insight_componentData.data.parameter_cache.category.includeBreakUp ? insight_componentData.data.parameter_cache.category.includeBreakUp : insight_include
                            insight_includeDisp = insight_componentData.includeDisp ? insight_componentData.includeDisp : insight_includeDisp
                            insight_exclude = insight_componentData.data.parameter_cache.category.excludeBreakUp ? insight_componentData.data.parameter_cache.category.excludeBreakUp : insight_exclude
                            insight_excludeDisp = insight_componentData.excludeDisp ? insight_componentData.excludeDisp : insight_excludeDisp
                            insight_startDate = insight_componentData.data.parameter_cache.date.startDate ? insight_componentData.data.parameter_cache.date.startDate : insight_startDate
                            insight_endDate = insight_componentData.data.parameter_cache.date.endDate ? insight_componentData.data.parameter_cache.date.endDate : insight_endDate
                        }                                                
                    }                    
                    insight_periodComparison = insight_componentData.periodComparison ? insight_componentData.periodComparison : insight_periodComparison
                    insight_dashboardConfig = insight_componentData.dashboardConfig ? insight_componentData.dashboardConfig : insight_dashboardConfig
                    insight_chartType = insight_componentData.chartType ? insight_componentData.chartType : this.props.chartType
                    insight_chartCat = insight_componentData.chartCat ? insight_componentData.chartCat : insight_chartCat
                    insight_metricRange = insight_componentData.metricRange ? insight_componentData.metricRange : insight_metricRange
                }                
            }
            
            // startDate={this.props.dataset_info.dataSet.startDate} endDate={this.props.dataset_info.dataSet.endDate}

            let pointToUse = checkIfMetricPoint(this.props.insightPoint, insight_selectedMetricDisp)
            pointToUse = pointToUse ? pointToUse : checkIfMetricPoint(this.props.pointMetric, insight_selectedMetricDisp)
            let insightType = this.props.insight ? 'insight' : (this.props.deepInsight ? 'deepInsight' : null)

            let period = insight_period && typeof insight_period == "object" ? insight_period.value : insight_period;
            period = period === null ? "null" : period;
            
            let insightDate = this.props.insightDate
            // if (insight_property && (insight_property.split(',')).length > 1 && (!period || period && period.toLowerCase() == 'aggregate')) {
            //     pointToUse = `${pointToUse},${insightDate}`
            //     insightDate = '';
            // }            
            var openStatus = this.getOpenStatus();

            // Handle property to use
            let propertyToUse = refineURLData(insight_property) ? insight_property : this.props.clickedDimension            
            
            filter_component = ['summary', 'chart', 'report', 'pinboard'].indexOf(this.props.pageName) !== -1 ? <SidebarInsight authData={this.props.authData} insightChart={insight_chartCat} chart={insight_chartCat} insightProperty={propertyToUse} propertyDisp={insight_propertyDisp} insightBreakup={insight_breakup} breakup={insight_breakup} breakupDisp={insight_SelectedBreakUpDisp} metric={this.props.pointMetric ? this.props.pointMetric : insight_selectedMetric} insightMetric={this.props.insightMetric} insightInclude={insight_include} include={insight_include} includeDisp={insight_includeDisp} insightExclude={insight_exclude} exclude={insight_exclude} excludeDisp={insight_excludeDisp} insightStartDate={insight_startDate} insightEndDate={insight_endDate} periodComparison={insight_periodComparison} mainMetric={this.props.metricGlobal} date={insightDate} point={pointToUse} newPage={false} insightPeriod={period} period={period} insightType={insightType} dashboard_config={insight_dashboardConfig}/> : null;

            if ((this.props.enableDescription || voiceQuestion == "1")) {
                let period = this.state.period;
                period = period ? period : (this.state.insightDate ? this.state.chartType : '');    // Set the period only when date is set
                descriptionComponentVariable = ['summary', 'chart', 'report'].indexOf(this.props.pageName) !== -1 ? <DescriptionComponent ref='descriptionRef' authData={this.props.authData} selectedMetric={decodeURIComponent(this.props.pointMetric ? this.props.pointMetric : insight_selectedMetric)} chartCat={'Bar'} period={period} startDate={insight_startDate} endDate={insight_endDate} category={propertyToUse} breakUp={insight_breakup} include={insight_include} exclude={insight_exclude} metricRange = {insight_metricRange} date={insightDate} point={pointToUse} insightPeriod={period} insightType={insightType} enableDescription={this.props.enableDescription} insightSortOrder={this.props.insightSortOrder} /> : null;
            }

        }
        // descriptionComponentVariable = null
        
        const commonProps = {
            ref: 'topfilter',
            selectedMetricDisp: this.state.selectedMetricDisp,
            property: this.state.property,
            enable_filter: enable_top_filter,
            menu: menu_array,
            allData: this,
            type: this.props.pageName === "chart" ? "charts" : this.props.pageName,
            updateMetricRange: this.updateMetricRange,
            dataSet: this.props.dataset_info.dataSet,
            transpose: this.props.transpose,
            kpiMonitoring: this.props.kpiMonitoring,
            compare: this.props.compare,
            period: this.state.period,
            dashbordGroups: this.props.dashbordGroups,
            authData: this.props.authData,
            dashboardConfig: this.props.dashboardConfig,
            filter_open_body: filter_open_body,
            filterHandleChange: this.filterHandleChange,
            allDashboards: this.props.allDashboards,
            dataResult: this.props.dataResult,
            changeDataSet: this.changeDataSet,
            dataLabelOverlap: this.props.dataLabelOverlap,
            metricRange: this.props.metricRange,
            restrictedFilter: this.props.restrictedFilter,
            ishomePage  : window.location.pathname == "/" || window.location.pathname == "/start" 
          };
          
          const isPageNameValid = ["", "start", "alldashboards", "dataset", "landingpage", "globaldashboards", "pinboard", "listalldashboards"].indexOf(this.props.pageName.toLowerCase()) === -1;
          const isTabDashboards = getParameters('tab') === "dashboards";
          
          const renderTopFilters = (isPageNameValid || isTabDashboards) && metricGlobal.length > 0;
          
          var TopfiltersVar = renderTopFilters ? <Topfilters {...commonProps} /> : null;

        let validRoute = ["", "start", "alldashboards", "dataset", "landingpage", "chart", "report", "notification", "alfred", "summary", "pinboard", "downloadarea", "userconfiguration", "insight", "deepinsight", "oops", "query", "setting", "admin", "globaldashboards", "adminpanel", "listalldashboards","requestlogs"];
        
        // Commented below to handle js error within each component by passing pageError flag
        // if (validRoute.indexOf(this.props.pageName.toLowerCase()) != -1 && !this.state.pageError) {
        if (validRoute.indexOf(this.props.pageName.toLowerCase()) != -1) {

            if (["", "start", "dataset", "admin", "alldashboards", "globaldashboards", "adminpanel"].indexOf(this.props.pageName.toLowerCase()) == -1 && (!this.state.loadStatus || metricGlobal.length == 0 || this.props.pageName == "landingPage")) {
                var ActualData = null;
            } else {
                // This is to prevent here multiple times call when
                // case1: New chart selected from the nav bar
                let case1 = getParameters('nav') !== 'new';
                // case2: When Alfred question asked it passes old property then only new question in case of chart
                let case2 = getParameters('question') ? this.props.property == decodeURIComponent(getParameters('property')) ? true : false : true;
                if (case1 && case2) {
                    var ActualData = 
                    // <ErrorBoundary key={window.location.pathname}>
                        <Switch>
                        <Route exact path={`/`} component={(props) => <DashBoardHome {...props} state={this.state} handleLoadingStatus = {this.handleLoadingStatus} />} />
                        <Route path={`/dataset`} component={(props) => <DashBoardHome {...props}state={this.state} handleLoadingStatus = {this.handleLoadingStatus} />} />
                        <Route path={`/admin`} component={(props) => <DashBoardHome {...props} state={this.state} handleLoadingStatus = {this.handleLoadingStatus}/>} />
                        <Route path={`/adminpanel/v2`} component={(props) => <DashBoardHome {...props} state={this.state} handleLoadingStatus = {this.handleLoadingStatus}/>} />
                        <Route path={`/start`} component={(props) => <DashBoardHome {...props} state={this.state} handleLoadingStatus = {this.handleLoadingStatus}/>} />
                        <Route path={`/alldashboards`} component={(props) => <AllDashboards {...props} />} />
                        <Route path={`/alfred`} component={Alfred} />
                        <Route path={`/summary`} component={Summary} />
                        {/* <Route path={`/pinboard`} component={ (props) => <PinboardcreateCombination {...props} filterHandleChange={this.filterHandleChange} />} /> */}
                        {/*Changed to below path from /pinboard/listall, as it was giving UI issues, causing pinboard UI to execute below list page */}
                        <Route exact path={`/listalldashboards`} component={PinboardList} />
                        <Route path={`/pinboard`} component={PinboardcreateCombination} />
                        <Route path={`/globaldashboards`} component={PinboardcreateCombination} />
                        {/* <Route path={`/chart`} component={ (props) => <Chart {...props} drillHandle={this.drillHandle} />} /> */}
                        <Route path={`/chart`} component={Chart} />
                        {/* <Route path={`/report`} component={ (props) => <Report {...props} drillHandle={this.drillHandle} />} /> */}
                        <Route path={`/report`} component={ReportPage} />
                        <Route path={`/requestLogs/:requested_from`} component={APIRequest} />
                        <Route path={`/downloadArea`} component={DownloadArea} />
                        {/* <Route path={`/userconfiguration`} component={UserConfiguration} /> */}
                        <Route path={`/notification`} component={Notifications} />
                        {/* <Route path={`/insight`} component={SidebarInsight} /> */}
                        <Route path={`/insight`} component={SidebarInsight} />
                        <Route path={`/deepinsight`} component={SidebarInsight} />
                        <Route path={`/setting`} component={SettingsComponent} />
                        <Route path={`/oops`} component={(props) => <NoDataFound data={"Oops! Sorry, could not understand this question."} subText={
                            <p style={{ textAlign: 'center' }}>
                                Please find Tips to help you get the best out of this search experience. Our team has already noted this issue and will resolve it at the earliest. Thank you!<br /><br />If these issues persist, do write to us at techsupport@rockmetric.com</p>
                        } />} />
                    </Switch>
                    // </ErrorBoundary>
                    ;
                }
            }
        } else {
            var ActualData = <NoDataFound data={"We could not load this component. Please reach out to your administrator for resolution."}
                subText={
                    <p style={{ textAlign: 'center' }}>
                        Rockmetric team will look into the issue. Go back to Dataset Page  <a className="btn btn-sm btn-white" href="/start">Dataset</a>
                    </p>
                } />
        }

        if(!checkIfFeatureApplicable('Search Bar')) {        
            AlfredSearchBodyMargin = { marginTop: '-4%'}
        }
        let cardClass = ['pinboard', 'insight'].indexOf(this.props.pageName.toLowerCase()) === -1 ? 'card-header':''
        screen_width = jQuery(window).width() 
        let ishomePage  = window.location.pathname == "/" || window.location.pathname == "/start" 
        let paddingValue = null 
        if(screen_width < mobile_width ||screen_width < tablet_width && ishomePage){
            paddingValue = {paddingTop:"60px"}
        }else{
            paddingValue ={paddingTop:"20px"}
        }

        function hideContextMenu() {
            let ele = document.getElementById("context-menu-dataset");
            ele?.classList?.add("d-none")
        }
        let homePage = (this.props.pageName.toLowerCase() === "start" || this.props.pageName.toLowerCase() === "") && getParameters('tab') !== "dashboards";
        let mobile = jQuery(document).width() < mobile_width || jQuery(document).width() < tablet_width 
        return (
            <>
            {this.state.isReloading || (this.props?.dataResult[0] && this.props?.dataResult[0]?.siteId != this.props?.authData?.siteId) ? <div style={{display : "flex" , justifyContent:"center" , alignItems : "center",height:"85vh"}}><LoadingComponent messages={["Please wait a moment... ","Fetching your queries..."]}/></div> : <>
                {this.props.tvMode == false
                    ? <>
                    {/* temp horizontal navbar for mobile  */}
                    {['start', "", 'setting', 'dataset',].indexOf(this.props.pageName.toLowerCase()) !== -1 ? <nav class="content-header d-none mobile-d-none bg-white bd-b-1" style={{borderBottomWidth:"1px"}}> </nav>:null } 
                        <DashBoardSideBar match={this.props} menuOptions={menu_array} />
                        <div className="content ht-100v pd-0" onClick={document.getElementById("context-menu-dataset") ? () => hideContextMenu() : null}>

                            {/* <div className="content-header">
                        <div className="content-search">
                            <i data-feather="search"></i>
                            <input type="search" className="form-control" placeholder="Search..." />
                        </div>
                    </div> */}

                            {getParameters("tab") == "dashboards" ? <AlfredComponent ref="alfredComponentRef" question={this.state.alfred_question ? this.state.alfred_question : this.props.alfred_question} questionId='' allProps={this} /> : ['start', "", 'setting', 'dataset', 'landingPage'].indexOf(this.props.pageName.toLowerCase()) === -1 ? <AlfredComponent ref="alfredComponentRef" question={this.state.alfred_question ? this.state.alfred_question : this.props.alfred_question} questionId='' allProps={this} /> : null}
                            
                            <div className={`${homePage ? "mobile-pd-t-20" : "custom-pd-t" } pd-l-5 pd-r-5`}
                                >
                                {TopfiltersVar}
                                {/* <div className="content-body" style={filter_open_body}> */}
                                <div className={`${['pinboard'].indexOf(this.props.pageName.toLowerCase()) === -1 ? 'dashboardClass' : ""} ${cardClass} border-0 ${['summary'].indexOf(this.props.pageName.toLowerCase()) === -1 ? "": screen_width<mobile_width ? "pt-0":""} 
                                ${['requestLogs'].indexOf(this.props.pageName) === -1 ? "": screen_width<mobile_width ? "pt-1":""}`} style={openStatus ? {} : filter_open_body}>
                                    <div className={`${['pinboard'].indexOf(this.props.pageName.toLowerCase()) === -1 ? 'row row-xs m-0' : 'row m-0'}`}>
                                        <div className={`${screen_width>mobile_width ?'col-lg-12 pd-t-0':"col-lg-12 pd-l-5 pd-r-5"}`}>
                                            {ActualData}
                                            {['pinboard', 'insight'].indexOf(this.props.pageName.toLowerCase()) === -1 ? descriptionComponentVariable : null}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pd-t-0">
                                {openStatus ? null : filter_component}
                            </div>
                        </div>
                    </>
                    : <>{ActualData}</>}
            </>}
                
            </>
        )
    }
}

function mapStateToProps(state) {
    var initial_data_from_url = {};
    initial_data_from_url = getURLDataHandle(state);
    var urlsForPageName = ["chartData", "report", "summary", "query"];

    // if(urlsForPageName.indexOf(initial_data_from_url.currentPageName.split("?")[0])==-1){
    //     initial_data_from_url = {currentPageName: initial_data_from_url.currentPageName}
    // }
    let finalObj = stateToPropsHandle(initial_data_from_url, state)
    if (finalObj.currentPageName == 'query')
        return finalObj

    // set global settings
    highChartsDiv = ['pinboard','globaldashboards'].indexOf(initial_data_from_url.currentPageName)>-1 ? [] : null;
    colors = state.dataSet.dataSet ? (state.dataSet.dataSet.userDBSetting ? JSON.parse(state.dataSet.dataSet.userDBSetting[0].color) : []) : [];
    gradientColorArray = state.dataSet.dataSet ? (state.dataSet.dataSet.userDBSetting && state.dataSet.dataSet.userDBSetting[0].colorGradient ? JSON.parse(state.dataSet.dataSet.userDBSetting[0].colorGradient) : []) : [];
    list_users = JSON.stringify(state.dataSet.getAllUsers);
    default_color = state.dataSet.dataSet ? (state.dataSet.dataSet.userDBSetting ? state.dataSet.dataSet.userDBSetting[0].default_color : null) : null;
    setCSSComp(process.env, "table");
    // end set global settings
    // if(urlsForPageName.indexOf(initial_data_from_url.currentPageName.split("?")[0])>-1){
    updateURL(finalObj, "");
    // }
    // window.location.href = window.location.href.replace("&nav=new","");
    return { ...finalObj, oldFilter: state.dataSet.oldFilter || false, initialDataApiFlag: state.dataSet.initialDataApiFlag, tvMode: state.dataSet.tvMode || false, alfredChartFlag: state.dataSet.alfredChartFlag, datasetChange: state.dataSet.datasetChange || false }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getData, getToolsData, get_property_metric_breakup, getQuestion, setQuestion, set_initial_values_url, setInsightFunction, set_disp_objects, setDrillHandle, setSummary, removeFilter, handle_compare, handle_quadrant, handle_transpose_table, setData, setTableActions, saveFilterToggleHandle, handle_restricted_Filter, setKpiColumnConfig, setChartQuestion, setGlobalFilters
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(DashBoardParent);